import React from "react";

function RecruitSvg() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0001 0C6.72893 0 0 6.72893 0 15.0001C0 23.2712 6.72893 30 15.0001 30C23.2712 30 30.0002 23.2711 30.0002 15.0001C30.0002 6.72906 23.2711 0 15.0001 0ZM15.0001 25.8717C9.00549 25.8717 4.12856 20.9948 4.12856 15.0001C4.12856 9.00535 9.00549 4.12842 15.0001 4.12842C20.9947 4.12842 25.8716 9.00535 25.8716 15.0001C25.8716 20.9948 20.9947 25.8717 15.0001 25.8717ZM20.4508 13.0491C20.4508 10.0212 18.3257 8.14002 14.9048 8.14002H9.83665V21.8601H12.7424V18.0375H14.9049C15.0323 18.0375 15.167 18.0343 15.3056 18.0275L18.1018 21.8603H21.7029L18.2941 17.1896C19.6857 16.3209 20.4508 14.8536 20.4508 13.0491ZM14.9048 15.1319H12.7424V11.0458H14.9049C17.5453 11.0458 17.5453 12.5534 17.5453 13.0491C17.5453 13.5641 17.5453 15.1319 14.9048 15.1319Z"
        fill="#C80D0D"
      />
    </svg>
  );
}

export default RecruitSvg;
